import { memo } from 'radash';

export const isEmail = memo((email: string) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
});
